import { render, staticRenderFns } from "./NewContainer.vue?vue&type=template&id=243b57f0&"
import script from "./NewContainer.vue?vue&type=script&lang=js&"
export * from "./NewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports